import windowLocalStorage from "../utils/localStorage";

export function getFromEnvVarsOrLocalStorage(str) {
  return process.env[str] || windowLocalStorage?.getItem(str);
}

